<mat-card>
  <mat-card-content>
    <div class="content" [class]="document?.uname" [class.only-first-colum]="onlyColumnOne"
         [class.only-second-colum]="onlyColumnTwo"
         [innerHTML]="document?.content?.replace('<p>&nbsp;</p>', '')"></div>
  </mat-card-content>
</mat-card>
